export class CNPJ {
  public static isValid(cnpj: string): boolean {
    if (this.REGEX_INVALID_CHARS.test(cnpj)) {
      return false;
    }

    const bare = this.removeMask(cnpj);
    if (!this.REGEX_FULL.test(bare) || bare === CNPJ.CNPJ_ZEROS) {
      return false;
    }

    const dvInformed = bare.substring(this.BASE_LENGTH);
    const dvCalculated = this.calculaDV(bare.substring(0, this.BASE_LENGTH));
    return dvInformed === dvCalculated;
  }

  public static calculaDV(cnpj: string): string {
    if (this.REGEX_INVALID_CHARS.test(cnpj)) {
      throw new Error('CNPJ inválido: contém caracteres não permitidos');
    }

    const bare = this.removeMask(cnpj);

    if (!this.REGEX_BASE.test(bare) || bare === CNPJ.CNPJ_ZEROS.substring(0, this.BASE_LENGTH)) {
      throw new Error('CNPJ inválido: base deve ter exatamente 12 caracteres [A-Z0-9] e não pode ser zerada');
    }

    let sum1 = 0;
    let sum2 = 0;
    for (let i = 0; i < this.BASE_LENGTH; i++) {
      const value = bare.charCodeAt(i) - this.CHAR_ZERO;
      sum1 += value * this.DV_WEIGHTS[i + 1];
      sum2 += value * this.DV_WEIGHTS[i];
    }

    const dv1 = sum1 % 11 < 2 ? 0 : 11 - (sum1 % 11);
    sum2 += dv1 * this.DV_WEIGHTS[this.BASE_LENGTH];
    const dv2 = sum2 % 11 < 2 ? 0 : 11 - (sum2 % 11);

    return `${dv1}${dv2}`;
  }

  private static readonly BASE_LENGTH = 12;
  private static readonly REGEX_BASE = /^([A-Z\d]){12}$/;
  private static readonly REGEX_FULL = /^([A-Z\d]){12}(\d){2}$/;
  private static readonly REGEX_MASK = /[./-]/g;
  private static readonly REGEX_INVALID_CHARS = /[^A-Z\d./-]/i;
  private static readonly CHAR_ZERO = '0'.charCodeAt(0);
  private static readonly DV_WEIGHTS = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  private static readonly CNPJ_ZEROS = '00000000000000';

  private static removeMask(cnpj: string): string {
    return cnpj.replace(this.REGEX_MASK, '');
  }
}
